import { cn } from "@newxsystems/shared";
import type { AnchorHTMLAttributes } from "react";
import { getComponent } from "../../../../client";
import type { IMegaMenuLinkProps } from "./MegaMenuLink.props";

export const MegaMenuLink = ({ className, link, onActivate }: IMegaMenuLinkProps) => {
  const Link = getComponent<AnchorHTMLAttributes<HTMLAnchorElement>>("Link");

  if (!Link) {
    return null;
  }

  const opensNewTab = link.openInNewTab === true;

  return (
    <Link
      aria-label={link.accessibilityLabel ?? link.label}
      className={cn(
        "min-w-0 [overflow-wrap:anywhere] transition-colors duration-200 focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-ring",
        className,
      )}
      href={link.href}
      onClick={onActivate}
      rel={opensNewTab ? "noopener noreferrer" : undefined}
      target={opensNewTab ? "_blank" : undefined}
    >
      {link.label}
    </Link>
  );
};

MegaMenuLink.displayName = "MegaMenu::MegaMenuLink";
